module.exports = __webpack_public_path__ + "img/igd-neg.7eea6ad1.svg";